import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "banner" }
const _hoisted_2 = {
  key: 0,
  class: "txtBannerProcesoDD"
}
const _hoisted_3 = {
  key: 1,
  class: "txtBannerDD"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 2,
  class: "txtBannerDDRechazada"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Aportes en Línea", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Nómina Electrónica", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "nominaelectronica@aportesenlinea.com", -1)
const _hoisted_9 = {
  key: 3,
  class: "txtBannerDDRechazada"
}
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.estadoDD == 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Nos encontramos realizando las validaciones de la información suministrada en el \"Registro Único de Clientes\". Pronto recibirás un correo confirmando la finalización del proceso. "))
      : _createCommentVNode("", true),
    ($props.estadoDD == 2)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createElementVNode("b", null, [
            _createElementVNode("a", {
              href: $setup.UrlDebidaDiligencia,
              target: "_self"
            }, "Aquí", 8, _hoisted_4)
          ]),
          _createTextVNode(" podrás actualizar la información suministrada en el \"Registro Único de Clientes\". Ten en cuenta que, si no realizas la actualización, no podrás realizar la compra de planes. ")
        ]))
      : _createCommentVNode("", true),
    ($props.estadoDD == 4)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
          _createTextVNode("Gracias por elegir "),
          _hoisted_6,
          _createTextVNode(". En este momento, no es posible continuar con la compra de planes para el servicio de "),
          _hoisted_7,
          _createTextVNode(". Si deseas obtener más información, puedes comunicarte con nosotros a través del correo electrónico: "),
          _hoisted_8,
          _createTextVNode(". ")
        ]))
      : _createCommentVNode("", true),
    ($props.estadoDD == 5)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _createElementVNode("strong", null, [
            _createElementVNode("a", {
              href: $setup.UrlDebidaDiligencia,
              target: "_self"
            }, "Aquí", 8, _hoisted_10)
          ]),
          _createTextVNode(" podrás actualizar la información suministrada en el \"Registro Único de Clientes\". ")
        ]))
      : _createCommentVNode("", true)
  ]))
}